import { axisColor, tickLabelFontSize, axisLabelFontSize, fontFamily } from '../../../reports/blocks/common/axes/constants'

export const nivoTheme = {
  axis: {
    domain: {
      line: {
        stroke: axisColor,
        strokeWidth: 1
      }
    },
    legend: {
      text: { fontFamily: fontFamily, fontSize: axisLabelFontSize, fill: axisColor }
    },
    ticks: {
      line: { stroke: axisColor },
      text: { fontFamily: fontFamily, fontSize: tickLabelFontSize, fill: axisColor }
    }
  }
}
